import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getStudentExams({ payload }) {
  try {
    yield put(actions.addStudentExamsLoading(true));
    const result = yield call(api.listAllMainStudentExams, payload);
    yield put(actions.getStudentExamsSuccess(result.data));
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to fetch student exams");
    yield put(actions.getStudentExamsFail());
  } finally {
    yield put(actions.addStudentExamsLoading(false));
  }
}

function* redoExam({ payload, action }) {
  try {
    yield put(actions.addStudentExamsLoading(true));
    const result = yield call(api.redoExam, payload);
    toast.success(result.data?.message || "Exam redo request sent successfully");
    yield put(actions.redoExamSuccess(result.data));
    if (action) {
      action();
    }
    yield put(actions.getStudentExamsRequest());
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to redo exam");
    yield put(actions.redoExamFail());
  } finally {
    yield put(actions.addStudentExamsLoading(false));
  }
}

function* getStudentExamsByExam({ payload }) {
  try {
    yield put(actions.addStudentExamsLoading(true));
    const result = yield call(api.getStudentExamsByExamId, payload);
    yield put(actions.getStudentExamsByExamSuccess(result.data?.data ?? result.data));
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to fetch exam submissions");
    yield put(actions.getStudentExamsByExamFail());
  } finally {
    yield put(actions.addStudentExamsLoading(false));
  }
}

function* getCorrectionQuestions({ payload }) {
  try {
    const result = yield call(api.getCorrectionQuestions, payload);
    yield put(actions.getCorrectionQuestionsSuccess(result.data?.data ?? result.data));
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to fetch questions");
    yield put(actions.getCorrectionQuestionsFail());
  }
}

function* correctStudentExam({ payload, action }) {
  try {
    const result = yield call(api.correctStudentExam, payload);
    toast.success(result.data?.data || "Exam corrected successfully");
    yield put(actions.correctStudentExamSuccess(result.data));
    if (action) {
      action();
    }
    if (payload?.exam_id) {
      yield put(actions.getStudentExamsByExamRequest(payload.exam_id));
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to correct exam");
    yield put(actions.correctStudentExamFail());
  }
}

function* getCorrectedQuestions({ payload }) {
  try {
    const result = yield call(api.getCorrectedQuestions, payload);
    yield put(actions.getCorrectedQuestionsSuccess(result.data?.data ?? result.data));
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to fetch correction");
    yield put(actions.getCorrectedQuestionsFail());
  }
}

function* getStudentExamReportByChapter({ payload }) {
  try {
    yield put(actions.addStudentExamsLoading(true));
    const result = yield call(api.getStudentExamReportByChapter, payload);
    yield put(actions.getStudentExamReportByChapterSuccess(result.data));
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to fetch exam report");
    yield put(actions.getStudentExamReportByChapterFail());
  } finally {
    yield put(actions.addStudentExamsLoading(false));
  }
}

function* refuseStudentExam({ payload, action, examId }) {
  try {
    const result = yield call(api.refuseStudentExam, payload);
    toast.success(result.data?.message || result.data?.data || "Exam refused successfully");
    yield put(actions.refuseStudentExamSuccess(result.data));
    if (action) action();
    if (examId) {
      yield put(actions.getStudentExamsByExamRequest(examId));
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to refuse exam");
    yield put(actions.refuseStudentExamFail());
  }
}

export default function* StudentExamsSaga() {
  yield takeLatest(Types.GET_ADMIN_STUDENT_EXAMS_MAIN_REQUEST, getStudentExams);
  yield takeLatest(Types.REDO_EXAM_REQUEST, redoExam);
  yield takeLatest(Types.GET_STUDENT_EXAMS_BY_EXAM_REQUEST, getStudentExamsByExam);
  yield takeLatest(Types.GET_CORRECTION_QUESTIONS_REQUEST, getCorrectionQuestions);
  yield takeLatest(Types.CORRECT_STUDENT_EXAM_REQUEST, correctStudentExam);
  yield takeLatest(Types.GET_CORRECTED_QUESTIONS_REQUEST, getCorrectedQuestions);
  yield takeLatest(Types.GET_STUDENT_EXAM_REPORT_BY_CHAPTER_REQUEST, getStudentExamReportByChapter);
  yield takeLatest(Types.REFUSE_STUDENT_EXAM_REQUEST, refuseStudentExam);
}
